import { permission, Permission, workspace, Workspace, WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { API_PATHS, ROUTE_PARAMS } from '../../app-core/constants';
import { interpolatePathParams } from '../../path';
import { fromNormalisedStoreSelector, NormalisedData } from '../../redux-helpers';

/**
 * Selector to get workspaces.
 *
 * @param {NormalisedData<unknown>} normalised - normalised store
 * @returns {Workspace[] | null}
 */
export const workspacesSelector = (
  normalised: NormalisedData<unknown>
): Workspace[] | WorkspacesListingItem[] | null => {
  const legacyWorkspace = fromNormalisedStoreSelector<Workspace[]>(normalised, [workspace], API_PATHS.WORKSPACES);
  if (legacyWorkspace) {
    return legacyWorkspace;
  }

  const workspaces = fromNormalisedStoreSelector<WorkspacesListingItem[]>(
    normalised,
    [workspace],
    API_PATHS.ALL_WORKSPACES_DATA
  );
  if (workspaces) {
    return workspaces;
  }

  return null;
};

/**
 * Selector to get workspaceById.
 *
 * @param {NormalisedData<unknown>} normalised - normalised store
 * @param {string} workspaceId - ids to retrieve.
 * @returns {Workspace | null}
 */
export const workspaceByIdSelector = (
  normalised: NormalisedData<unknown>,
  workspaceId: string
): Workspace | WorkspacesListingItem | null => {
  const workspaces = workspacesSelector(normalised);

  if (!workspaces) {
    return null;
  }

  if (workspaces) {
    return (workspaces as []).find((wks: Workspace | WorkspacesListingItem) => wks.id === workspaceId) || null;
  }

  return null;
};

/**
 * Selector to get workspaceById.
 *
 * @param {NormalisedData<unknown>} normalised - normalised store
 * @param {string} workspaceId - ids to retrieve.
 * @returns {Workspace | null}
 */
export const workspacePermissionsByIdSelector = (
  normalised: NormalisedData<unknown>,
  workspaceId: string
): Permission[] | null => {
  const path = interpolatePathParams(API_PATHS.WORKSPACE_PERMISSIONS, { [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId });

  return fromNormalisedStoreSelector<Permission[]>(normalised, [permission], path);
};
